import React, {Component} from 'react';
import ProgressBar from "react-bootstrap/ProgressBar";
import "./page_progress_bar.scss";

class PageProgressBar extends Component<any, any> {

    interval?: NodeJS.Timeout;

    constructor(props: any) {
        super(props);

        this.state = {
            position: 0
        };

        this.setUpdateInterval();
    }

    componentDidMount(): void {
    }

    componentWillUnmount(): void {
        this.clear();
    }

    clear() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    reset() {
        this.setState({
            position: 0
        });
        if (!this.interval) {
            this.setUpdateInterval();
        }
    }

    setUpdateInterval() {
        const speed = this.props.speed ? this.props.speed : 1.0/8.0;

        this.interval = setInterval(() => {

            let newPosition = this.state.position + (100 - this.state.position)*speed;

            if(newPosition > 99.9) {
                this.clear();
            }

            this.setState({
                position: newPosition
            });

        }, 100);
    }

    render() {
        return (
            <ProgressBar now={this.state.position} className={this.props.className + " page-progress-bar"}/>
        );
    }
}

export default PageProgressBar;